export const handleNavigation = <T, K>(
    id: T,
    data: K,
    setData: (value: K) => void,
    handle: (key: T, v: K) => K
) => {
    setData(handle(id, data));
};
